module.exports = __webpack_public_path__ + "static/images/list-g-a.e9b5926.png";